var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewOutboundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.496 2.144a2 2 0 012.121 1.192l4.006 9.348a2 2 0 01-.424 2.202l-2.881 2.881a14.893 14.893 0 007.854 7.855l2.882-2.882a2 2 0 012.202-.424l9.347 4.006a2 2 0 011.192 2.121l-1.26 8.817a2 2 0 01-1.886 1.715c-8.735.406-17.611-2.727-24.284-9.4C4.69 22.9 1.558 14.025 1.964 5.29a2 2 0 011.715-1.887l8.817-1.26zM5.931 7.123a28.118 28.118 0 008.262 19.623 28.118 28.118 0 0019.624 8.262l.802-5.613-6.694-2.869-2.837 2.837a2 2 0 01-2.047.483 18.891 18.891 0 01-11.948-11.948 2 2 0 01.483-2.046l2.837-2.837-2.869-6.694-5.613.801z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.333 5.945a1.667 1.667 0 010-3.333h8.334c.92 0 1.666.746 1.666 1.666v8.334a1.667 1.667 0 01-3.333 0v-4.31l-7.155 7.155a1.667 1.667 0 11-2.357-2.357l7.155-7.155h-4.31z"
  }))));
}

export default SvgNewOutboundIcon;